import DetailTemplateLabourCostOnSite from './DetailTemplateLabourCostOnSite';

export default DetailTemplateLabourCostOnSite;
